import { APPT_BOOKING_REASON_MAX, OTP_LENGTH } from "common/constants";
import { number, object, string } from "yup";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const apptBookReasonValidation = (required = true) => {
	let schema = string();

	if (required) {
		schema = schema.required("Required");
	} else {
		schema = schema.notRequired();
	}

	schema = schema.max(APPT_BOOKING_REASON_MAX, `Must be at most ${APPT_BOOKING_REASON_MAX} characters`);

	return schema;
};

export const stringRequired = (fieldName, { min = 1, max = 1500 } = {}) => string()
	.required(`${fieldName} is required`)
	.max(max, `${fieldName} must be at most ${max} characters`)
	.min(min, `${fieldName} must be at least ${min} characters`)

export const phoneValidation = (isPhoneRequired = false) =>
	object().shape({
		phone: isPhoneRequired
			? string().required("Phone is required")
			: string().nullable(),
		country_code: isPhoneRequired
			? string().required("Country code is required")
			: string().nullable(),
	}).test(
    "is-valid-phone",
    function (value) {
      const { phone, country_code } = value || {};

      // If phone/country_code missing, let field-level validation handle it
      if (!phone || !country_code) {
        return true;
      }

      const fullPhone = `${country_code}${phone}`;
      const phoneNumber = parsePhoneNumberFromString(fullPhone);

      const isValid = phoneNumber?.isValid() || false;
      if (!isValid) {
        return this.createError({ path: "phone", message: {phone: "Please enter a valid phone number"} });
      }

      return true;
    }
	);

export const otpValidation = number()
	.required("Please enter OTP")
	.test(
			"len",
			`OTP must be of ${OTP_LENGTH} digits`,
			(val) => val && val.toString().length === OTP_LENGTH
	);